<template>
  <div class="space-y-4">
    <!-- Title skeleton -->
    <Skeleton v-if="showTitle" class="h-8 w-1/2 rounded" />

    <!-- Content skeleton based on type -->
    <div v-if="type === 'card'" class="space-y-3">
      <Skeleton class="h-6 w-3/4 rounded" />
      <Skeleton class="h-4 w-full rounded" />
      <Skeleton class="h-4 w-5/6 rounded" />
      <Skeleton class="h-10 w-full rounded" />
    </div>

    <div v-else-if="type === 'list'" class="space-y-3">
      <div v-for="n in count" :key="n" class="flex items-center gap-3">
        <Skeleton class="h-4 w-4 rounded shrink-0" />
        <Skeleton class="h-4 w-full rounded" />
      </div>
    </div>

    <div v-else-if="type === 'accordion'" class="space-y-2">
      <div v-for="n in count" :key="n" class="space-y-2">
        <Skeleton class="h-10 w-full rounded" />
        <Skeleton class="h-4 w-full rounded" />
        <Skeleton class="h-4 w-4/5 rounded" />
      </div>
    </div>

    <div v-else-if="type === 'grid'" class="grid gap-4" :class="gridClass">
      <div v-for="n in count" :key="n" class="space-y-3">
        <Skeleton class="h-40 w-full rounded" />
        <Skeleton class="h-5 w-3/4 rounded" />
        <Skeleton class="h-4 w-1/2 rounded" />
      </div>
    </div>

    <div v-else class="space-y-2">
      <Skeleton v-for="n in count" :key="n" class="h-4 w-full rounded" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    type?: "card" | "list" | "accordion" | "grid" | "text";
    count?: number;
    showTitle?: boolean;
    gridClass?: string;
  }>(),
  {
    type: "text",
    count: 3,
    showTitle: false,
    gridClass: "md:grid-cols-2 lg:grid-cols-3",
  }
);
</script>
